import React from 'react'
import { InputTextarea } from 'primereact/inputtextarea'

export default function LtsTextArea(props) {
  const onChange = (event) => {
    const target = event.target
    props.onChange(target.value)
  }

  const resolveLabel = () => {
    if (props.label && !props.hidden) {
      return <label>{props.label}</label>
    }
    return null
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <InputTextarea
          {...props}
          value={props.value}
          onChange={onChange}
          name={props.name}
          cols={30}
          autoResize={true}
          resizable={true}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
